import { useEffect, useMemo, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

import { breakpoints } from 'styles/mq'
import { useMedia } from 'hooks/useMedia'
import MapImageSrcLarge from './assets/world-large.png'
import MapImageSrcMedium from './assets/world-medium.png'
import {
  Container,
  List,
  ListContainer,
  ListItem,
  MapContainer,
  Title,
  ZoomContainer,
} from './styled'

const countries = {
  Швеция: require('./assets/Швеция.svg').default,
  Чехия: require('./assets/Чехия.svg').default,
  Хорватия: require('./assets/Хорватия.svg').default,
  Франция: require('./assets/Франция.svg').default,
  Финляндия: require('./assets/Финляндия.svg').default,
  Румыния: require('./assets/Румыния.svg').default,
  Португалия: require('./assets/Португалия.svg').default,
  Польша: require('./assets/Польша.svg').default,
  Нидерланды: require('./assets/Нидерланды.svg').default,
  Латвия: require('./assets/Латвия.svg').default,
  Италия: require('./assets/Италия.svg').default,
  Испания: require('./assets/Испания.svg').default,
  Греция: require('./assets/Греция.svg').default,
  Германия: require('./assets/Германия.svg').default,
  Венгрия: require('./assets/Венгрия.svg').default,
  Австрия: require('./assets/Австрия.svg').default,
}

const getPosition = (percent: number, isLarge: boolean) => {
  return `calc(-${percent}% + ${percent}vw - ${
    16 * (isLarge ? 1 : 0) * (percent / 100)
  }rem)`
}

export const Map = () => {
  const [currentIndex, setCurrentIndex] = useState(-1)
  const [hasInteracted, setInteracted] = useState(false)
  const isWide = useMedia(['(min-aspect-ratio: 3 / 1)'], [true], false)
  const isLarge = useMedia([breakpoints.large], [true], false)
  const [currentItemLabel, currentItemSrc] = useMemo(() => {
    if (currentIndex < 0) {
      return ['', '']
    }

    return Object.entries(countries)[currentIndex]
  }, [currentIndex])

  const handleClick = (index: number) => {
    setInteracted(true)
    setCurrentIndex(v => (v === index ? -1 : index))
  }

  useEffect(() => {
    let interval: NodeJS.Timeout

    if (!hasInteracted) {
      interval = setInterval(() => {
        setCurrentIndex(v => (v + 1) % Object.entries(countries).length)
      }, 2000)
    }

    return () => clearInterval(interval)
  }, [hasInteracted, setCurrentIndex])

  return (
    <Container>
      <ListContainer>
        <Title>Список стран</Title>
        <List>
          {Object.entries(countries).map(([label], index) => (
            <ListItem $isActive={index === currentIndex} key={label}>
              <button onClick={() => handleClick(index)}>{label}</button>
            </ListItem>
          ))}
        </List>
      </ListContainer>

      <MapContainer $hasMask={!!currentItemLabel && !isWide}>
        <ZoomContainer
          style={{
            transform: `translate(
            ${
              !currentItemLabel || isWide
                ? 0
                : getPosition(isLarge ? 55 : 50, isLarge)
            },
            ${
              !isLarge && !currentItemLabel
                ? 'calc(100vw - 40%)'
                : isLarge
                ? '-5%'
                : 0
            })
            scale(${currentItemLabel || isWide ? 1 : isLarge ? 0.5 : 0.25})`,
          }}
        >
          <picture>
            <source media={breakpoints.medium} srcSet={MapImageSrcLarge} />
            <motion.img src={MapImageSrcMedium} srcSet="" alt="" />
          </picture>

          <AnimatePresence>
            <motion.img
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              key={currentItemLabel}
              src={currentItemSrc}
              alt={currentItemLabel}
            />
          </AnimatePresence>
        </ZoomContainer>
      </MapContainer>
    </Container>
  )
}
